module.exports = __webpack_public_path__ + "img/9523a0654b79f7c3c7d3717e2ba9e4bb.png";